import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	fetchErrorTitle: {
		id: 'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.title',
		description: 'Title of flag shown when cover image from selected page cannot be fetched',
		defaultMessage: 'We can’t upload your image',
	},
	fetchErrorDescription: {
		id: 'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.description',
		description: 'Description of flag shown when cover image from selected page cannot be fetched',
		defaultMessage: 'Refresh the page and try again',
	},
});
